import Modal from './modal';
import TeamSlider from './team-slider';

class ModalDefault {
    constructor(el) {
        this.el = el;
        this.modalContent = this.el.querySelector('.js__modal--default-content').innerHTML;
        this.initializeModals();
    }

    reinitSliderDOM(el) {
        const outer = el.closest('.tns-outer');
        if (outer) {
            const container = outer.querySelector('.tns-slider');
            if (container) outer.replaceWith(container);
        }

        el.removeAttribute('style');
        el.classList.remove('tns-slider', 'tns-horizontal');

        el.querySelectorAll('.tns-item').forEach(n => {
            n.classList.remove('tns-item');
            n.removeAttribute('style');
            n.removeAttribute('id');
            n.removeAttribute('aria-hidden');
        });
    }

    initializeModals = () => {
        this.el.addEventListener('click', () => {
            Modal.show(this.modalContent);

			// Initialize and display the team member image slider
            setTimeout(() => {
                const modalEl = document.querySelector('.modal__content');
                if (!modalEl) return;

                const sliderEl = modalEl.querySelector('.js-team-member-slider');
                const prevBtn = modalEl.querySelector('.custom-prev-button');
                const nextBtn = modalEl.querySelector('.custom-next-button');
                const navContainer = modalEl.querySelector('.custom-nav-container');

                if (sliderEl && !sliderEl.classList.contains('initialized')) {

                    this.reinitSliderDOM(sliderEl);

                    new TeamSlider(sliderEl, prevBtn, nextBtn, navContainer);

                    sliderEl.classList.add('initialized');
                }
            }, 50);
        });
    };
}

export default ModalDefault;